<template>
  <div class="start-page" @click="goHome">
    <!-- PC端背景图 -->
    <div class="start-pc">
      <img src="@/assets/start-pc.png" class="bg-img pc-img" />
      <div class="enter-btn pc-img" @click.stop="goHome">ENTER >></div>
    </div>
    <!-- 移动端背景图 -->
    <div class="start-mobile">
      <img src="@/assets/start-mobile.png" class="bg-img mobile-img" />
      <div class="enter-btn mobile-img" @click.stop="goHome">ENTER >></div>
    </div>

    <!-- 底部版权 -->
    <div class="copyright">
      Copyright ©湖北省人才发展集团有限公司. All Rights Reserved
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goHome() {
      this.$router.push("/home");
    },
  },
};
</script>

<style scoped lang="less">
.start-page {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: #fff;
}

.bg-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  z-index: 1;
}

.pc-img {
  display: block;
}
.mobile-img {
  display: none;
}

.start-pc .enter-btn {
  position: absolute;
  left: 50%;
  top: 82%;
  transform: translate(-50%, -50%);
  z-index: 99;
  padding: 14px 25px;
  font-size: 20px;
  color: #fff;
  background: rgba(0, 60, 120, 0.75);
  border-radius: 32px;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

/* 进入按钮样式 */
.start-mobile .enter-btn {
  position: absolute;
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
  z-index: 99;
  padding: 10px 15px;
  font-size: 14px;
  color: #fff;
  background: rgba(0, 60, 120, 0.75);
  border-radius: 32px;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
}

.copyright {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 12px;
  color: #666;
  z-index: 99;
}

/* 移动端适配 */
@media (max-width: 992px) {
  .pc-img {
    display: none;
  }
  .mobile-img {
    display: block;
  }
  .enter-btn {
    font-size: 16px;
    padding: 10px 28px;
    top: 68%;
  }
}
</style>